import React, { useMemo, useContext } from 'react';
import classNames from 'classnames';
import { NotificationsPagePlacholder } from './placeholder';
import { useTranslation } from 'react-i18next';
import NotificationsContext from 'providers/Notifications/Notifications.context';
import ThreeDotsDropdown from 'components/ThreeDotsDropdown';
import NotificationCard from 'components/NotificationCard';
import NotificationUnreadToggle from 'components/NotificationsDrawer/components/NotificationUnreadToggle';
import InfiniteScroll from 'components/InfiniteScroll';

import './Notifications.styles.scss';
import './Notifications.styles.responsive.scss';

const Notifications: React.FC = () => {
  const classes = classNames('notifications');

  const { t } = useTranslation();

  const {
    numberOfPlaceholders,
    notifications,
    fetchingNotifications,
    readAllNotifications,
    onNotificationsScroll,
    redirectionPath,
    getDynamicRedirectionPath,
    onDeleteNotification,
    onReadNotification,
    onUnreadNotification,
    getCtaIcon,
    getCtaPrimary,
    getCtaSecondary,
    getCtaText,
    getContent,
    getIsLoadingNotification,
  } = useContext(NotificationsContext);

  const emptyPlaceholder = useMemo(
    () => (
      <div className="notifications__placeholder">
        {fetchingNotifications &&
          Array(numberOfPlaceholders)
            .fill(1)
            .map((_, i) => <NotificationsPagePlacholder key={i} />)}
      </div>
    ),
    [fetchingNotifications, numberOfPlaceholders],
  );

  return (
    <div className={classes}>
      <section className="notifications__actions">
        <p className="notifications__title">{t('notifications')}</p>
        <NotificationUnreadToggle />
        <ThreeDotsDropdown
          className="notifications-drawer__actions"
          options={[
            {
              label: 'Mark all as read',
              onClick: () => readAllNotifications(),
            },
          ]}
        />
      </section>

      <InfiniteScroll
        className="notifications__content"
        onScroll={onNotificationsScroll}
      >
        {!fetchingNotifications && !notifications.length ? (
          <div className="notifications__empty-state">
            <p>{t('youHaveNoNotificationsYet')}</p>
          </div>
        ) : (
          notifications.map((notif) => (
            <NotificationCard
              key={notif.id}
              notification={notif}
              loading={getIsLoadingNotification(notif.id)}
              to={redirectionPath(notif)}
              onDynamicTo={getDynamicRedirectionPath(notif)}
              onRead={(id) => onReadNotification(id, false)}
              onUnread={(id) => onUnreadNotification(id, false)}
              onDelete={onDeleteNotification}
              ctaPrimary={getCtaPrimary(notif)}
              ctaSecondary={getCtaSecondary(notif)}
              ctaText={getCtaText(notif)}
              ctaIcon={getCtaIcon(notif)}
              contentText={getContent(notif)}
            />
          ))
        )}
      </InfiniteScroll>

      {emptyPlaceholder}
    </div>
  );
};

export default Notifications;
